/**
 * date utils
 */
import dayjs from 'dayjs'

export function getMsFromDateString(dateString: string): number {
  const date = dayjs(dateString)
  return ((date.hour() * 60) + date.minute()) * 60000
}
